import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Debug hook to log all initialization details
 */
export const useDebugInitialization = () => {
  const location = useLocation();
  
  useEffect(() => {
    console.log('====== APP INITIALIZATION DEBUG ======');
    console.log('[Debug] Full URL:', window.location.href);
    console.log('[Debug] Origin:', window.location.origin);
    console.log('[Debug] Pathname:', window.location.pathname);
    console.log('[Debug] Hash:', window.location.hash);
    console.log('[Debug] Search:', window.location.search);
    console.log('[Debug] React Router Location:', location);
    console.log('[Debug] React Router Pathname:', location.pathname);
    console.log('[Debug] React Router Search:', location.search);
    console.log('[Debug] React Router Hash:', location.hash);
    
    // Check if we have Stripe parameters
    if (window.location.hash) {
      const hashString = window.location.hash.substring(1);
      console.log('[Debug] Hash without #:', hashString);
      
      // Check if it starts with /signup
      if (hashString.startsWith('/signup')) {
        console.log('[Debug] Hash starts with /signup - should route there');
        
        // Parse parameters
        const queryIndex = hashString.indexOf('?');
        if (queryIndex !== -1) {
          const queryString = hashString.substring(queryIndex + 1);
          const params = new URLSearchParams(queryString);
          console.log('[Debug] Parameters in hash:', {
            session_id: params.get('session_id'),
            email: params.get('email'),
            plan: params.get('plan')
          });
        }
      }
    }
    
    console.log('====== END DEBUG ======');
  }, [location]);
};